var _g, _path, _path2, _path3, _path4, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMegacable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 239.9 40.3",
    enableBackground: "new 0 0 239.9 40.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.7,22.3v7.8c-1.3,0.6-2.7,1-4.1,1c-1.4,0-2.7-0.4-3.8-1.2 c-1.2-0.7-2.1-1.8-2.7-3.3c-0.7-1.4-1-3-1-4.9c0.1-1.7,0.3-3.1,0.7-4.5c0.4-1.3,0.9-2.4,1.7-3.3c0.7-0.9,1.6-1.6,2.6-2.1 c1-0.5,2.1-0.7,3.3-0.7c1.2,0,2.3,0.2,3.5,0.8c1.2,0.5,2.1,1.4,3,2.6h0.5c0-0.4,0.1-0.9,0.3-1.6c0.2-0.7,0.4-1.3,0.6-1.8 c-2.4-1.3-5-2-8.1-2c-2.5,0-4.7,0.4-6.4,1.2c-1.8,0.7-3.2,1.7-4.2,2.9c-1.1,1.2-1.8,2.6-2.2,4c-0.5,1.5-0.7,2.9-0.7,4.4 c0,2.1,0.4,3.8,1.2,5.3c0.8,1.5,1.8,2.6,3.1,3.5c1.3,0.9,2.7,1.5,4.3,1.9c1.5,0.4,3.1,0.6,4.6,0.6c2.8,0,5.7-0.5,8.9-1.5v-9.3 c-0.9,0.1-1.7,0.2-2.5,0.2C109.4,22.5,108.6,22.5,107.7,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2,9.8v22.7h12.7c-0.1-0.5-0.1-0.9-0.2-1.3c0.1-0.4,0.2-1,0.3-1.6 c-2.5,0.3-5.1,0.5-7.7,0.5v-8.4h3.5c1.6,0,3,0.1,4,0.3c-0.1-0.4-0.1-0.9-0.2-1.3c0-0.2,0-0.4,0.1-0.7c0-0.3,0.1-0.6,0.1-0.9 c-0.8,0.2-1.9,0.3-3.2,0.3h-4.3v-7.1h1.1c2.1,0,4.3,0.1,6.5,0.4c-0.1-0.6-0.2-1.1-0.2-1.4c0.1-0.7,0.2-1.2,0.3-1.5H75.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.1,9.6c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6-0.1l-0.1,0.2l-9.4,23 c0.2,0,0.4,0,0.7-0.1c0.3,0,0.5,0,0.7-0.1c0.2,0,0.5,0.1,0.8,0.1c0.4,0,0.6,0,0.8,0.1c0.2-0.7,0.4-1.3,0.6-1.9 c0.2-0.7,0.5-1.6,1-2.7c0.4-1.2,0.7-1.9,0.8-2.3h3.9h3.8c0.9,2.3,1.6,4.6,2.3,6.9c0.3,0,0.8,0,1.4-0.1c0.6,0,1,0,1.3-0.1 c0.4,0,0.9,0.1,1.5,0.1c0.6,0,1.2,0,1.5,0.1l-9.3-23.1C127.3,9.5,126.8,9.5,126.1,9.6z M124.8,23.6h-3l3-7.5l0.1-0.2l3,7.7H124.8z "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9,21c-0.2-1.8-0.4-3.6-0.6-5.1c-0.2-1.6-0.4-3.6-0.7-6.1 c-0.5,0.1-1,0.1-1.4,0.2c-0.7-0.1-1.2-0.1-1.4-0.2c-0.6,1.3-1.3,2.7-2,4.2c-0.7,1.5-1.4,2.8-1.9,3.8c-0.5,1-1.1,2.2-1.8,3.6 c-0.7,1.3-1.4,2.7-2.1,4.1c-3.4-6.8-5.9-12-7.6-15.7c-0.2,0-0.7,0.1-1.4,0.2c-0.1,0-0.3,0-0.6-0.1c-0.3,0-0.5-0.1-0.7-0.1 c-0.5,3.8-1.1,7.8-1.6,11.8c-0.6,4-1.2,7.7-1.8,11.1c0.3,0,0.8-0.1,1.6-0.2c0.3,0.1,0.6,0.1,0.8,0.1c0.2,0,0.4,0.1,0.8,0.1 c0-1.2,0.1-2.6,0.2-4.3c0.1-1.7,0.3-3.6,0.5-5.6c0.2-2.1,0.4-3.8,0.6-5.3c0.4,0.8,0.9,1.9,1.6,3.3c0.7,1.4,1.3,2.6,1.7,3.6 c0.5,0.9,1.1,2.3,2,4.1c0.9,1.8,1.5,3.1,1.9,4h0.5h0.7c2.2-4.8,4.7-9.9,7.3-15.3c0.1,1.3,0.3,2.7,0.5,4.5c0.2,1.7,0.3,3.1,0.4,4 c0.1,0.9,0.2,2,0.3,3.3c0.1,1.3,0.2,2.6,0.2,3.8c0.9-0.1,1.8-0.2,2.7-0.2c0.9,0,1.8,0.1,2.7,0.2c-0.3-2.2-0.6-4.2-0.9-6.1 C70.3,24.7,70.1,22.8,69.9,21z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.7,9.6c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6-0.1l-0.1,0.2l-9.4,23 c0.2,0,0.4,0,0.7-0.1c0.3,0,0.5,0,0.7-0.1c0.2,0,0.5,0.1,0.8,0.1c0.4,0,0.7,0,0.8,0.1c0.2-0.7,0.4-1.3,0.6-1.9 c0.2-0.7,0.5-1.6,1-2.7c0.4-1.2,0.7-1.9,0.8-2.3h3.9h3.8c0.9,2.3,1.6,4.6,2.3,6.9c0.3,0,0.8,0,1.4-0.1c0.6,0,1.1,0,1.3-0.1 c0.4,0,0.9,0.1,1.5,0.1c0.6,0,1.2,0,1.5,0.1L171,9.5C170.9,9.5,170.4,9.5,169.7,9.6z M168.4,23.6h-3l3-7.5l0.1-0.2l3,7.7H168.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.6,30.1V9.8c-0.4,0-0.9,0.1-1.5,0.1c-0.6,0.1-0.9,0.1-1,0.1 c-0.8-0.1-1.6-0.1-2.4-0.2v22.7h12.6c-0.1-0.5-0.1-1-0.2-1.4c0.1-0.6,0.2-1.1,0.3-1.5C213.3,29.9,210.8,30.1,208.6,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.4,21.2c-0.9-0.4-1.9-0.6-2.9-0.7v-0.3c3.5-0.7,5.3-2.4,5.4-5.3 c0-1-0.2-1.9-0.8-2.7c-0.5-0.7-1.3-1.4-2.2-1.8c-1-0.4-2-0.6-3.3-0.6h-1.3h-7.8v22.7h7.3c0.2,0,0.3,0,0.4,0c1.2,0,2.3-0.2,3.2-0.5 c1.1-0.4,1.9-0.8,2.7-1.4c0.7-0.6,1.2-1.3,1.6-2.1c0.4-0.8,0.5-1.7,0.5-2.6c0-1.2-0.3-2.3-0.9-3C198,22.1,197.2,21.5,196.4,21.2z  M188.7,11.7c0.6-0.1,1.1-0.1,1.5-0.1c0.5,0,0.9,0.1,1.3,0.1c1.7,0.4,2.5,1.5,2.5,3.5c0,0.8-0.1,1.4-0.4,2 c-0.2,0.6-0.6,1.2-1.2,1.6c-0.3,0.2-0.6,0.4-1,0.5c-0.3,0.1-0.6,0.2-0.9,0.2c-0.3,0.1-1,0.1-1.9,0.1V11.7z M193.6,28.5 c-0.4,0.7-0.8,1.1-1.4,1.5c-0.3,0.2-0.5,0.3-0.8,0.4c-0.3,0.1-0.6,0.2-0.9,0.2h-1.9v-8.9h1c0.7,0,1.3,0.1,1.8,0.2 c1.9,0.5,2.8,2,2.8,4.4C194.2,27,194,27.8,193.6,28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.2,30.1v-8.4h3.5c1.6,0,3,0.1,4,0.3c-0.1-0.4-0.1-0.9-0.2-1.3 c0-0.2,0.1-0.4,0.1-0.7c0.1-0.3,0.1-0.6,0.1-0.9c-0.8,0.2-1.9,0.3-3.2,0.3h-4.3v-7.1h1.1c2.1,0,4.3,0.1,6.5,0.4 c-0.1-0.6-0.1-1.1-0.2-1.4c0.1-0.7,0.2-1.2,0.3-1.5h-12.7v22.7h12.6c-0.1-0.5-0.1-0.9-0.2-1.3c0.1-0.4,0.1-1,0.3-1.6 C230.4,29.9,227.8,30.1,225.2,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.5,12.4c1.2-0.8,2.5-1.2,4-1.2c1,0,2,0.2,3,0.8c1,0.5,1.8,1.3,2.5,2.3h0.4 c0.3-1.4,0.6-2.5,0.8-3.4c-0.5-0.4-1.5-0.8-2.7-1.1c-1.3-0.4-2.7-0.5-4.4-0.5c-1.8,0-3.7,0.3-5.6,1c-1.9,0.7-3.7,2-5.1,3.9 c-1.5,1.9-2.2,4.5-2.2,7.9c0,1.5,0.3,2.9,0.8,4.2c0.6,1.3,1.4,2.5,2.5,3.6c1.1,1,2.4,1.8,3.9,2.4c1.6,0.6,3.3,0.9,5.2,0.9 c2.7,0,4.9-0.5,6.6-1.4l0.7-2.9l-0.5-0.2c-0.7,0.8-1.6,1.4-2.8,1.8c-1.1,0.4-2.1,0.6-3.1,0.6c-1.7,0-3.2-0.4-4.4-1.2 c-1.2-0.8-2.1-2-2.7-3.4c-0.6-1.5-0.9-3.1-0.9-5c0-2.1,0.3-3.9,1-5.5C144.4,14.4,145.3,13.2,146.5,12.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.7,31.7c-0.1-0.1-0.1-0.1-0.2-0.2c0.2,0,0.4-0.1,0.6-0.2c0.1-0.2,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.1-0.4 c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1-0.1-0.3-0.1-0.5-0.1h-1.2v2.8h0.4v-1.2h0.3c0.2,0,0.3,0,0.4,0.1c0,0,0,0,0.1,0.1 c0.1,0.1,0.2,0.3,0.4,0.6l0.3,0.4h0.5l-0.3-0.6C237.9,32,237.8,31.8,237.7,31.7z M237.1,31.2h-0.6v-0.9h0.7c0.1,0,0.2,0,0.3,0.1 c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0.1C237.2,31.2,237.2,31.2,237.1,31.2 z M239.5,30.1c-0.2-0.4-0.6-0.7-1-1c-0.4-0.2-0.9-0.4-1.3-0.4c-0.4,0-0.9,0.1-1.3,0.4c-0.4,0.2-0.7,0.5-1,1 c-0.2,0.4-0.4,0.9-0.4,1.3c0,0.4,0.1,0.9,0.3,1.3c0.2,0.4,0.6,0.7,1,1c0.4,0.2,0.8,0.4,1.3,0.4c0.4,0,0.9-0.1,1.3-0.4 c0.4-0.2,0.8-0.5,1-1c0.2-0.4,0.3-0.9,0.3-1.3C239.9,30.9,239.7,30.5,239.5,30.1z M239.1,32.5c-0.2,0.3-0.4,0.6-0.8,0.8 c-0.4,0.2-0.7,0.3-1.1,0.3c-0.4,0-0.7-0.1-1.1-0.3c-0.3-0.2-0.6-0.5-0.8-0.8c-0.2-0.4-0.3-0.7-0.3-1.1c0-0.4,0.1-0.7,0.3-1.1 c0.2-0.3,0.5-0.6,0.8-0.8c0.3-0.2,0.7-0.3,1.1-0.3c0.4,0,0.7,0.1,1.1,0.3c0.3,0.2,0.6,0.5,0.8,0.8c0.2,0.4,0.3,0.7,0.3,1.1 C239.4,31.8,239.3,32.1,239.1,32.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 258.4526,
    cy: 172.7639,
    r: 83.0179,
    gradientTransform: "matrix(0.44 0 0 0.44 -93.6392 -67.4214)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#C2D9F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#0094D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#295BA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#001F4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_1_)",
    d: "M40.3,20.2C40.3,9,31.3,0,20.2,0C9,0,0,9,0,20.2s9,20.2,20.2,20.2 C31.3,40.3,40.3,31.3,40.3,20.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 258.4516,
    cy: 152.8148,
    r: 103.5086,
    gradientTransform: "matrix(0.44 0 0 0.44 -93.6392 -67.4214)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#C2D9F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#0094D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#295BA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#001F4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_2_)",
    d: "M8.8,9.3c-4.8,5.2-7.3,12-7.1,19.1c0,0,0,0,0,0c0.3,0.7,0.7,1.4,1.1,2.1 c1.3-6.9,4.7-13.3,9.9-18.3C12.1,10.7,10.6,9.6,8.8,9.3z M27.7,19.7C19,22.5,11.9,28.5,8,36.2c0.6,0.5,1.3,0.9,1.9,1.3 c5.3-6.1,12.7-10.5,21.2-12.1C31.1,23.1,29.8,20.9,27.7,19.7z M32.4,14.2c-0.8-2.7-2.7-5-5.6-6.2C14.9,11.9,6.5,21.4,4.4,32.8 c0.6,0.8,1.3,1.5,2,2.1C10.8,24.7,20.2,16.8,32.4,14.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 258.453,
    cy: 172.767,
    r: 82.7453,
    gradientTransform: "matrix(0.44 0 0 0.44 -93.6392 -67.4214)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1966,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#D0DCE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#747C82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_3_)",
    d: "M30.9,13.2c-0.8-2.7-2.8-4.9-5.6-6c-11.1,4.3-19,14.1-21,25.5 c0.6,0.8,1.2,1.5,1.9,2.1C10.5,24.4,19.4,16.2,30.9,13.2z M26.6,18.9c-8.3,3.1-15,9.3-18.8,17.2c0.6,0.5,1.2,0.9,1.9,1.3 c5.1-6.4,12.2-11,20.4-12.9C30.1,22.2,28.7,20,26.6,18.9z M8.4,9c-4.5,5.4-6.9,12.3-6.7,19.4c0.3,0.7,0.7,1.4,1.1,2.1 c1.2-7,4.5-13.5,9.3-18.7C11.5,10.3,10.1,9.2,8.4,9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 258.3185,
    cy: 168.9896,
    r: 87.0667,
    gradientTransform: "matrix(0.44 0 0 0.44 -93.6392 -67.4214)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C0E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#1071B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#213475"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_4_)",
    d: "M26.7,18.8L26.7,18.8L26.7,18.8c-4.2,1.5-7.9,3.8-11.2,6.8 c-3.2,3-5.8,6.5-7.7,10.5c0,0,0.1,0.1,0.1,0.1l0,0l0,0c1.9-3.9,4.4-7.4,7.7-10.4c3.2-3,6.9-5.2,11-6.8c2,1.1,3.3,3.2,3.5,5.5 c-8,1.8-15.3,6.4-20.4,12.9l0,0c0.1,0,0.1,0.1,0.2,0.1c0,0,0,0,0,0c5.1-6.5,12.4-11,20.4-12.9l0.1,0v-0.1 C30.1,22.1,28.8,19.9,26.7,18.8z M12.3,11.8L12.3,11.8c-0.7-1.6-2.1-2.7-3.8-2.9l0,0l0,0c-4.5,5.4-6.9,12.2-6.7,19.2 c0.1,0.1,0.1,0.3,0.2,0.4c0-0.1,0-0.2,0-0.2C1.6,21.3,4,14.5,8.5,9.1c1.6,0.2,2.9,1.2,3.6,2.7C7.2,17,4,23.4,2.8,30.4 c0,0.1,0.1,0.1,0.1,0.2l0,0l0,0l0,0C4.1,23.5,7.4,17.1,12.3,11.8L12.3,11.8z M31,13.2c-0.9-2.8-2.9-5-5.6-6.1l0,0l0,0 C19.9,9.2,15,12.7,11.3,17.2C7.7,21.6,5.3,27,4.3,32.6c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0,0l0,0l0,0c1-5.6,3.4-11,7-15.4 c3.7-4.5,8.4-8,13.8-10.1c2.6,1.1,4.6,3.2,5.4,5.9c-5.5,1.4-10.7,4.2-15,8c-4.2,3.7-7.5,8.4-9.5,13.6c0,0,0.1,0.1,0.1,0.1 c0,0,0,0,0,0l0,0l0,0c2.1-5.2,5.4-9.9,9.5-13.6c4.3-3.8,9.5-6.6,15-8L31,13.2L31,13.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2864A2",
    d: "M20.2,0C9,0,0,9,0,20.2c0,2.8,0.6,5.5,1.7,8C1.5,21.2,3.9,14.3,8.4,9l0,0l0,0c1.7,0.2,3.1,1.3,3.8,2.9 l0,0.1l0,0c-4.9,5.2-8.1,11.6-9.3,18.6l0,0l0,0l0,0c0.4,0.7,0.9,1.4,1.4,2c1-5.6,3.4-11,7.1-15.4c3.7-4.5,8.5-8,13.9-10.1l0,0l0,0 c2.7,1.1,4.7,3.3,5.6,6.1l0,0.1l-0.1,0c-5.6,1.4-10.7,4.2-15,8c-4.1,3.7-7.4,8.4-9.5,13.6l0,0l0,0c0.4,0.4,0.9,0.8,1.4,1.2 c1.9-4,4.5-7.5,7.7-10.4c3.2-3,7-5.3,11.1-6.8l0,0l0,0c2.1,1.1,3.5,3.3,3.6,5.7v0.1l-0.1,0C22.2,26.4,15,31,9.8,37.5 c3,1.8,6.6,2.9,10.3,2.9c11.1,0,20.2-9,20.2-20.2S31.3,0,20.2,0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegacable);
export default __webpack_public_path__ + "static/media/megacable.fdf33bc4c2b5bd15edff28d930136cb3.svg";
export { ForwardRef as ReactComponent };